import { FrontHeaderTopLayout } from '#theme';
import { useTranslation } from '@framework/i18n';
import React from 'react';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import { MainMenu } from '../../../routes/menu/MainMenu';
import { RightMenu } from '../../../routes/menu/RightMenu';

export interface PageLayoutHeaderProps {
  boxed?: boolean;
  fixed?: boolean;
  extra?: React.ReactNode;
  variant?: 'default' | 'public';
}

/**
 * Fascia in alto della pagina che contiene il logo,
 * il menu principale, il menu delle notifiche e quello dell'utente
 */
export function PageLayoutHeader(props: PageLayoutHeaderProps) {
  const { boxed, extra, variant = 'default' } = props;
  const { t } = useTranslation();
  const isMobile = useBreakpoint(down('md'));

  if (variant === 'public') {
    return (
      <FrontHeaderTopLayout
        boxed={boxed}
        minimal
        title={t(
          'shared-resource.portal-title',
          'Portale dei procedimenti e dei servizi al cittadino',
        )}
        right={<RightMenu publicOnly isMobile={isMobile} />}
      />
    );
  }

  return (
    <FrontHeaderTopLayout
      boxed={boxed}
      right={<RightMenu extra={extra} isMobile={isMobile} />}
      // right={
      //   isMobile ? (
      //     <MobileFullMenu extra={extra} />
      //   ) : (
      //     <RightMenu extra={extra} isMobile={isMobile} />
      //   )
      // }
      main={!isMobile && <MainMenu />}
    />
  );
}
